import { Icon, IconProps } from "../Icon";

const CheckboxCheckedFilled = (props: IconProps) => (
  <Icon fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 4H6C4.89543 4 4 4.89543 4 6V26C4 27.1046 4.89543 28 6 28H26C27.1046 28 28 27.1046 28 26V6C28 4.89543 27.1046 4 26 4ZM14 21.5L9 16.5L10.59 15L14 18.35L21.41 11L23 12.58L14 21.5Z"
      fill="currentColor"
    />
  </Icon>
);

export default CheckboxCheckedFilled;
